import { FC, useEffect, useState } from 'react'
import RPI from 'react-phone-input-2'

// https://github.com/vitejs/vite/issues/2139#issuecomment-1133130323
// @ts-ignore
const ReactPhoneInput = RPI.default ?? RPI

interface PhoneInputProps {
	value?: string
	onChange?: (value: string | undefined) => void
	country?: string
	onBlur?: () => void
	containerClass?: string
	excludeCountries?: string[]
	[key: string]: any // For any additional props
}

const PhoneInput: FC<PhoneInputProps> = ({ value, onChange, ...props }) => {
	const [localValue, setLocalValue] = useState(value || '')

	useEffect(() => {
		if (value !== localValue) {
			setLocalValue(value || '')
		}
	}, [value])

	const handleChange = (phone: string) => {
		setLocalValue(phone)
		if (onChange) {
			const formattedPhone = phone ? `+${phone}` : undefined
			onChange(formattedPhone)
		}
	}

	return <ReactPhoneInput {...props} value={localValue} onChange={handleChange} countryCodeEditable={false} />
}

export default PhoneInput
